<template>
	<v-dialog
		v-model="dialog"
		:max-width="maxWidth"
		:overlay-opacity="overlayOpacity"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<template v-slot:activator="{ on, attrs }">
			<v-btn
				v-if="onlyIcon"
				icon
				:fab="openBtnDesign.includes('fab') ? true : false"
				:outlined="openBtnDesign.includes('outlined') ? true : false"
				:fixed="openBtnDesign.includes('fixed') ? true : false"
				:absolute="openBtnDesign.includes('absolute') ? true : false"
				:shaped="openBtnDesign.includes('shaped') ? true : false"
				:rounded="openBtnDesign.includes('rounded') ? true : false"
				:right="openBtnDesign.includes('right') ? true : false"
				:top="openBtnDesign.includes('top') ? true : false"
				:left="openBtnDesign.includes('left') ? true : false"
				:bottom="openBtnDesign.includes('bottom') ? true : false"
				:color="openBtnColor"
				small
				:text="false"
				@click.stop="dialog = true"
				v-bind="attrs"
				v-on="on"
			>
				<slot name="icon">
					<v-icon>mdi-help-circle</v-icon>
				</slot>
			</v-btn>
			<v-btn
				v-else
				:text="openBtnDesign.includes('text') ? true : false"
				:outlined="openBtnDesign.includes('outlined') ? true : false"
				:color="openBtnColor"
				@click.stop="dialog = true"
				v-bind="attrs"
				v-on="on"
			>
				<v-icon class="mr-2">mdi-help-circle</v-icon>
				<slot name="btn-text"> ヘルプ </slot>
			</v-btn>
		</template>

		<v-card>
			<v-app-bar dense dark flat color="primary">
				<v-app-bar-title class="color-white"> ヘルプ </v-app-bar-title>
				<v-spacer />
				<v-btn v-if="$vuetify.breakpoint.xs" @click="dialog = false" icon>
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-app-bar>
			<v-sheet elevation="0" class="pt-2">
				<template v-for="(help, i) in Object.entries(helps)">
					<v-card-subtitle
						v-if="help[0]"
						:key="i"
						class="pa-2 text-subtitle-1 font-weight-bold black--text"
					>
						{{ help[0] }}
					</v-card-subtitle>
					<v-card-text
						v-for="(text, j) in help[1]"
						:key="`${j}-${i}`"
						class="pa-2 pt-0 text-body-2 font-weight-regular black--text"
					>
						{{ text }}
					</v-card-text>
				</template>
			</v-sheet>
			<v-card-actions>
				<v-row class="ma-0 pa-0" justify="center">
					<v-col sm="4" />
					<v-col sm="4"> </v-col>
					<v-col sm="4">
						<v-row align="center">
							<v-spacer></v-spacer>
							<v-btn
								v-if="!$vuetify.breakpoint.xs"
								color="grey darken-1"
								text
								@click="dialog = false"
							>
								閉じる
							</v-btn>
						</v-row>
					</v-col>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
<script>
import helpTexts from "../../helper/help.json"

export default {
	props: {
		overlayOpacity: {
			type: String,
			default: "0.7",
			required: false,
		},
		// ダイアログを開くボタンのデザインを配列で受け取る
		openBtnDesign: {
			type: Array,
			default: () => [],
			required: false,
		},
		// ダイアログを開くボタンの色
		openBtnColor: {
			type: String,
			default: "secondary",
			required: false,
		},
		// ダイアログのmax-width
		maxWidth: {
			type: String,
			default: "700px",
			required: false,
		},
		// ダイアログが開くボタンのアイコンのみを指定
		onlyIcon: {
			type: Boolean,
			required: false,
			default: false,
		},
		name: {
			type: String,
			required: true,
			default: null,
		},
	},
	data() {
		return {
			dialog: false,
			helps: helpTexts[this.name],
		}
	},
	watch: {
		name(newVal, _) {
			this.helps = helpTexts[newVal]
		},
	},
}
</script>
